import React, { useContext as useContextCore, useEffect } from 'react'
import type { ListFieldConfig, UseListResult } from '@ztechapps/common.hook'
import { useContext } from '../Context'
import { useListFieldConfig } from './constants'
import { usePublicProductList } from '@ztechapps/product.common'

export type ProviderProps = {
  children: React.ReactNode
}

export type ContextType = {
  listResult: UseListResult
  productListFieldConfig: ListFieldConfig
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const GridViewProvider = ({ children, ...props }: ProviderProps) => {
  const { setProductsCount, filter } = useContext()

  const productListFieldConfig = useListFieldConfig()
  const listResult = usePublicProductList({
    filter,
  })

  const count = listResult?.pageInfo?.count ?? 0
  useEffect(() => {
    setProductsCount(count)
  }, [count, setProductsCount])

  return <CoreProvider value={{ listResult, productListFieldConfig, ...props }}>{children}</CoreProvider>
}

export const useGridViewContext = () => useContextCore(context)
